/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { get, isObject } from "lodash";
import systemAlert from "../../../utils/systemAlert";
import { viewLoading } from "../../../utils/loading";
import useForm from "../../../hooks/useForm";
import { dateToViewFormatWithDayNameWithTime, getDay } from "../../../utils/date";
import { isEmpty } from "../../../utils/lodashExtend";
import { CARE_COMPANY_MEMO_COMPLETED } from "../../../constants/CARE_COMPANY";
import Modal, { ModalHeader } from "../../Modal";
import Icon from "../../Icon";
import Form from "../../Form";
import NoticeIcon from "../../../assets/images/icon/notice-icon.svg";
import { addTaxpayerSchedule, editTaxpayerSchedule, taxpayerScheduleCategoryList } from "../../../apis/tax-portal/taxpayer";
import { toast } from "../../../utils/toast";
import { TAXPAYER_SCHEDULE_VIEW_RANGE_TYPE } from "../../../constants/TaxPortal/TAXPAYER_TYPE";
import { isNumber } from "../../../utils/validator";
import Comment from "../../Comment";
import { shallowEqual, useSelector } from "react-redux";
import { isFunction } from "lodash";


const defaultForm = {
  date: getDay(0),
  title: "",
  content: "",
  fileIdxes: [],
  completed: "0",
  viewRange: "manager",
};

const TaxCompanyScheduleDetail = ({
  managerCompany,
  schedule,
  setSchedule,
  toggle,
  setToggle,
  formType,
  submit,
  setFormType,
  taxpayer,
}) => {

  const {
    taxpayerList,
  } = useSelector(
    (store) => ({
      taxpayerList: store.Data.taxpayerList,

    }),
    shallowEqual
  );

  const [mode, setMode] = useState(formType);
  const [buttons, setButtons] = useState([]);
  const [taxpayers, setTaxpayers] = useState([]);
  const [categories, setCategories] = useState([]);
  const [isModeChange, setIsModeChange] = useState(false);

  const reset = () => {
    setMode('create');
    resetForm(defaultForm);
  };

  const close = (e) => {
    if (e) {
      e.preventDefault();
    }
    setSchedule && setSchedule(null);
    setToggle(false);
    reset();

  };

  const [fields, setFields] = useState([]);


  const _submit = (_form) => {
    const form = {
      ..._form,
      date: `${_form.date[0]}:00`,
      fileIdxes: (_form.fileIdxes || []).map(item => isNumber(item) ? item : item.fileIdx),

    };

    if (form?.idx) {
      delete form.idx;
    }

    if (mode === "create") {
      systemAlert(`"${form.title}" 일정을 등록하시겠습니까?`, {

        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {
              viewLoading(true);
              addTaxpayerSchedule(managerCompany.companyIdx, form)
                .then((res) => {
                  toast.success('등록되었습니다.');
                  close();
                  submit && submit();
                })
                .finally(() => {
                  viewLoading(false);
                });
            }
          }
        ]
      });
    } else if (mode === "modify") {
      systemAlert(`"${form.title}" 일정을 수정 하시겠습니까?`, {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {

              viewLoading(true);
              editTaxpayerSchedule(managerCompany.companyIdx, schedule.idx, form)
                .then((res) => {
                  toast.success('수정되었습니다.');
                  close();
                  submit && submit();
                })
                .finally(() => {
                  viewLoading(false);
                });
            }
          }
        ]
      });
    }
  };

  const {
    form,
    errors,
    setValidateFields,
    setForm,
    handleOnChange,
    handleSubmit,
    resetForm,
  } = useForm(
    defaultForm,
    _submit,
  );

  useEffect(() => {
    setValidateFields(fields);
  }, [fields]);

  useEffect(() => {
    !isEmpty(form) && setFields([
      [
        {
          isHide: mode !== 'view',
          title: "작성일",
          type: 'component',
          component: () => {
            return <>{dateToViewFormatWithDayNameWithTime(get(schedule, 'createdTime'))}</>;
          }
        },
        {
          isHide: mode !== 'view',
          title: "작업일",
          type: "component",
          required: true,
          component: () => {
            return <>{dateToViewFormatWithDayNameWithTime(get(schedule, 'date'))}</>;
          }
        },
      ],
      [
        {
          title: "상호명",
          isHide: mode !== 'view',
          key: "companyName",
          type: "text",
        },
        {
          title: "대표자명",
          isHide: mode !== 'view',
          key: "ceoName",
          type: "text",
        },
      ],
      [
        {
          title: "카테고리",
          isHide: mode !== 'view',
          key: "category",
          onValue: (v) => !isEmpty(v) ? v.name : "-"
        },
        {
          isHide: mode !== 'view',
          title: "노출범위",
          key: "viewRange",
          onValue: (v) => TAXPAYER_SCHEDULE_VIEW_RANGE_TYPE.find(f => f.value === v)?.label || "-"
        }
      ],
      [
        {
          title: "수임회사",
          key: "taxpayerIdx",
          type: "search-select",
          options: { list: taxpayers },
          zIndex: 100,
          isControlShouldRenderValue: true,
          isHide: mode === "view",
          onChange: (data) => {
            setForm({
              taxpayerIdx: data?.value,
              companyName: data?.companyName,
              ceoName: data?.ceoName,
            });
          },
          disabled: !isEmpty(taxpayer)
        },
        {
          title: "카테고리",
          key: "categoryIdx",
          type: "select",
          className: "zIndex-0",
          options: {
            list: categories
          },
          isHide: mode === "view",
          onChanged: ({ form, onChange }) => {
            const categoryName = categories.find(f => f.value === +form.categoryIdx)?.name || "";
            const companyName = form.companyName || "";

            isModeChange
              ? setIsModeChange(false)
              : onChange({ title: `${companyName && companyName + " "}${categoryName}` });
          }
        },
      ],
      [
        {
          title: "작업일",
          key: "date",
          type: "datetimepicker",
          isHide: mode === "view",
          required: true,
          component: () => {
            return <>{dateToViewFormatWithDayNameWithTime(get(schedule, 'date'))}</>;
          }
        },
        {
          title: "노출범위",
          type: "select",
          className: "zIndex-0",
          key: "viewRange",
          isHide: mode === "view",
          options: {
            list: TAXPAYER_SCHEDULE_VIEW_RANGE_TYPE
          },
          required: true,
        }
      ],

      [
        {
          title: "상호명",
          isHide: mode === "view",
          key: "companyName",
          type: "text",
          onChanged: ({ form, onChange }) => {
            const categoryName = categories.find(f => f.value === +form.categoryIdx)?.name || "";
            const companyName = form.companyName || "";
            isModeChange
              ? setIsModeChange(false)
              : onChange({ title: `${companyName && companyName + " "}${categoryName}` });
          }
        },
        {
          title: "대표자명",
          isHide: mode === "view",
          key: "ceoName",
          type: "text",
        },
      ],
      {
        title: "제목",
        key: "title",
        type: "input",
        required: true,
      },
      {
        title: "내용",
        key: "content",
        type: "editor",
        className: 'zIndex-0',
        height: 200
      },
      {
        title: "첨부파일",
        key: "fileIdxes",
        type: "dropzone",
        required: false,
      },
      {
        isHide: mode === 'view',
        title: "처리여부",
        key: "completed",
        type: "select",
        className: "zIndex-0",
        defaultValue: !isEmpty(schedule) && isObject(schedule) ? String(get(schedule, 'completed')) : form.completed,
        options: {
          list: CARE_COMPANY_MEMO_COMPLETED,
        },
      },
      {
        isHide: mode !== 'view',
        title: "처리여부",
        key: "completed",
        onValue: (value) => {
          const data = CARE_COMPANY_MEMO_COMPLETED.find((e) => e.value === String(value));
          if (data) {
            return data.label;
          } else {
            return '';
          }
        }
      },
    ]);

  }, [form, taxpayers, categories, mode, taxpayer]);

  useEffect(() => {
    if (!isEmpty(schedule)) {
      setForm({
        ...schedule,
        companyName: schedule?.management?.companyName,
        ceoName: schedule?.management?.ceoName,
        bsno: schedule?.management?.bsno,
        fileIdxes: schedule.uploadFiles || [],
        date: !isEmpty(schedule?.date) ? [schedule.date] : [],
      });
    }

    setMode(formType);
    if (formType === "create" || formType === "modify") {
      setButtons([
        {
          label: "닫기",
          color: 'text',
          onClick: close
        },
        {
          label: formType === "create" ? "작성완료" : "수정",
          onClick: handleSubmit,
        },
      ]);
    } else if (formType === "view" && isFunction(setFormType)) {
      setButtons([
        {
          label: "닫기",
          color: 'text',
          onClick: close,
        },
        {
          label: "수정 화면 이동",
          onClick: () => {
            setFormType("modify");
            setIsModeChange(true);
          }
        },
      ]);
    }
  }, [schedule, mode, isModeChange]);

  useEffect(() => {
    if (!isEmpty(taxpayer)) {
      setForm({
        ...(taxpayer && {
          taxpayerIdx: taxpayer.idx,
          companyName: taxpayer.companyName,
          ceoName: taxpayer.ceoName,
          bsno: taxpayer.bsno,
        }),
      });
    }
  }, [taxpayer]);

  useEffect(() => {
    if (toggle && taxpayerList) {
      taxpayerScheduleCategoryList({ search: { isActive: true } })
        .then(res => {
          const categories = (res?.rows || []).map(item => {
            return {
              ...item,
              label: item.name,
              value: item.idx,
            };
          });
          setCategories(categories);

          if (!schedule.categoryIdx || !isNumber(schedule.categoryIdx)) {
            setForm({ categoryIdx: categories[0]?.value });
          }
        });


      const taxpayers = (taxpayerList).map(item => {
        return {
          ...item,
          label: `${item.companyName} (${item.ceoName})`,
          value: item.idx,
        };
      });

      setTaxpayers([{ label: "선택안함", value: null }, ...taxpayers]);
    }

  }, [toggle, taxpayerList]);

  return (
    <Modal
      isOpen={toggle}
      close={close}
    >
      <div className="client-write">
        <ModalHeader>
          <Icon src={NoticeIcon} />&nbsp;
          일정 {mode === 'create' && "작성"}
        </ModalHeader>
        <Form
          mode={mode}
          isRequiredShow={true}
          fields={fields}
          form={form}
          onChange={handleOnChange}
          // submit={handleSubmit}
          // cancelText={'닫기'}
          // cancel={close}
          errors={errors}
          buttons={buttons}
        >
          {mode === 'view' && schedule && (
            <div className="file-upload-list">
              {/* <label className="file-upload-label"></label> */}
              <div className="file-upload-form">
                <Comment
                  postIdx={schedule.idx}
                  postType="taxpayerSchedule"
                  submit={submit}
                  isFirstSubmit={false}
                  isReadCheck={false}
                />
              </div>
            </div>
          )}
        </Form>
      </div>
    </Modal>
  );
};


export default TaxCompanyScheduleDetail;
